import { i18nMark } from '@lingui/react';

export function validateProfile(data) {
    const errors = {};

    if (!data.name || data.name.trim() === '') {
        errors.name = i18nMark('validation:error:mandatory:field');
    }

    if (data.ruleStrategy === 'include_specific') {
        if (!data.selectedProperties || data.selectedProperties.length === 0) {
            errors.selectedProperties = i18nMark('profiles:validation:select_at_least_one_property');
        }
    }

    return errors;
}
